import { useState, useEffect, useCallback } from 'react';
import proyectoApi from '../services/api/proyectoApi';
import { isCorporativoProject } from '../utils/projectRouteAccess';
import {
  getSelectedProject,
  isValidRrhhProyectoId,
  RRHH_CORPORATIVO_PROYECTO_KEY,
} from '../utils/rrhhProyectoHelpers';

/**
 * Contexto de proyecto para pantallas RRHH.
 * En modo corporativo permite elegir el proyecto de trabajo sin cambiar la sesión global.
 */
export function useRrhhProyecto() {
  const sessionProject = getSelectedProject();
  const isCorporativo = isCorporativoProject(sessionProject);

  const [proyectoId, setProyectoIdState] = useState(() => {
    if (isCorporativo) {
      try {
        const saved = localStorage.getItem(RRHH_CORPORATIVO_PROYECTO_KEY);
        return saved && isValidRrhhProyectoId(saved) ? Number(saved) : null;
      } catch {
        return null;
      }
    }
    return sessionProject?.id && isValidRrhhProyectoId(sessionProject.id)
      ? Number(sessionProject.id)
      : null;
  });

  const [proyectos, setProyectos] = useState([]);
  const [loadingProyectos, setLoadingProyectos] = useState(isCorporativo);

  const setProyectoId = useCallback((id) => {
    const numId = id && isValidRrhhProyectoId(id) ? Number(id) : null;
    setProyectoIdState(numId);
    if (isCorporativo) {
      if (numId) {
        localStorage.setItem(RRHH_CORPORATIVO_PROYECTO_KEY, String(numId));
      } else {
        localStorage.removeItem(RRHH_CORPORATIVO_PROYECTO_KEY);
      }
    }
  }, [isCorporativo]);

  useEffect(() => {
    if (!isCorporativo) return undefined;

    let cancelled = false;
    setLoadingProyectos(true);
    proyectoApi
      .getParaFormulario(-1)
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
        setProyectos(list);
      })
      .catch(() => {
        if (!cancelled) setProyectos([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingProyectos(false);
      });

    return () => { cancelled = true; };
  }, [isCorporativo]);

  const proyectoIdEfectivo = isValidRrhhProyectoId(proyectoId) ? Number(proyectoId) : null;

  return {
    isCorporativo,
    proyectoId: proyectoIdEfectivo,
    setProyectoId,
    proyectos,
    loadingProyectos,
    needsProyectoSelection: isCorporativo && !proyectoIdEfectivo,
  };
}

export default useRrhhProyecto;
